exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".witness-wrap {\n  padding: 3px 10px 10px 10px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-radius: 5px;\n  background-color: transparent;\n  margin: 10px 0px;\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .witness-wrap .mat-checkbox-frame {\n    border-color: #0e0e0e !important; }\n  .witness-wrap .mat-checkbox-checked .mat-checkbox-background {\n    background-color: #0e0e0e !important; }\n\n.witness-wrap-add {\n  padding: 4px 0 5px;\n  border-bottom: 1px solid #efefef;\n  margin-bottom: 25px; }\n\n.witness-wrap-add__button {\n  background-color: black;\n  color: white;\n  margin: 10px auto;\n  -ms-flex-pack: center;\n      justify-content: center; }\n  .witness-wrap-add__button__right {\n    -ms-flex-item-align: end;\n        align-self: flex-end;\n    justify-self: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/involved-parties/involved-parties.component.scss
// module id = ../../../../../src/app/shared/components/involved-parties/involved-parties.component.scss
// module chunks = main